import React, { useState, useEffect } from "react";
import { slide as Menu } from "react-burger-menu";
import HamburgerIcon from "hamburger-react";
import NavbarService from "../services/navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import "../assets/css/hamburger.css";
import tel from "../assets/images/tel.svg";
import globe from "../assets/images/globe.svg";
import { useParams } from "react-router-dom";

export default function Hamburger(props) {
  const [isOpen, setOpen] = useState(false);
  let [navbarData, setNavbarData] = useState([]);

  let { lang } = useParams();

  useEffect(() => {
    getNavbarData();
  }, []);

  const getNavbarData = async () => {
    try {
      let res = await NavbarService.getNavbar();
      setNavbarData(res);
    } catch {
      console.error();
    }
  };

  var isMenuOpen = function (state) {
    setOpen(state.isOpen);
  };

  // i คือ index ในรายการที่เรียงแล้ว — ห้ามเทียบกับ id เพราะ id ไม่ได้เรียงตามลำดับเมนู
  const openDropdown = (i) => {
    setNavbarData(
      navbarData.map((e, idx) => (idx === i ? { ...e, active: !e.active } : e))
    );
  };

  function switchLang() {
    const currentPath = window.location.pathname;
    const currentLanguage = currentPath.split("/")[1]; // get the current language code from the path
    let newLanguage;
    if (currentLanguage === "en") {
      newLanguage = "th";
    } else if (currentLanguage === "th") {
      newLanguage = "en";
    }
    let newPath;
    if (currentPath.endsWith(`/${currentLanguage}`)) {
      // if the current path ends with "/en" or "/th", replace it with the new language code
      newPath = currentPath.replace(`/${currentLanguage}`, `/${newLanguage}`);
    } else {
      // otherwise, replace the language code in the middle of the path
      newPath = currentPath.replace(`/${currentLanguage}/`, `/${newLanguage}/`);
    }
    window.location.href = window.location.origin + newPath;
  }

  return (
    <div className="block lg:hidden">
      <Menu
        id="hamburger-menu"
        onStateChange={isMenuOpen}
        right
        customBurgerIcon={<HamburgerIcon toggled={isOpen} />}
      >
        <div className="!flex flex-col mt-[25px]">
          {navbarData &&
            navbarData.map((item, i) => (
              <span key={i} className="flex flex-col py-[15px] px-[30px]">
                <div
                  className="flex gap-[5px] items-center"
                  onClick={() => openDropdown(i)}
                >
                  <Link
                    to={item.link && item.link === "-" ? "" : `/${lang}${item.link}`}
                    className={
                      item.link && item.link === "-"
                        ? "pointer-events-none"
                        : undefined
                    }
                  >
                    <h1
                      id="home"
                      className="cursor-pointer menu-item font-normal text-body text-black uppercase text-left"
                      href="/"
                    >
                      {lang === "th" ? item.name_th : item.name_en}
                    </h1>
                  </Link>
                  {item.subMenu.length !== 0 && (
                    <FontAwesomeIcon
                      icon={faChevronLeft}
                      className={
                        "transition duration-200 h-[14px] w-[14px] cursor-pointer text-black " +
                        (item.active ? "-rotate-90" : null)
                      }
                    />
                  )}
                </div>

                {item.active && item.subMenu.length !== 0 && (
                  <ul className="mt-[15px] ml-[15px] list-disc flex flex-col gap-[12px]">
                    {item.subMenu.map((item, i) => (
                      <Link key={i} to={`/${lang}${item.href}`}>
                        <li className="text-left text-small cursor-pointer capitalize whitespace-nowrap text-black">
                          {lang === "th" ? item.label_TH : item.label_EN}
                        </li>
                      </Link>
                    ))}
                  </ul>
                )}
              </span>
            ))}
          <div>
            <div className="py-[15px] px-[30px] flex items-center justify-start bg-darkGray3 gap-[16px]">
              <img className="w-[23px]" src={tel} alt="" />
              {props.data && props.data[1] && (
                <p className="text-body text-white">
                  {lang === "th"
                    ? props.data[1].detail.detail_TH
                    : props.data[1].detail.detail_EN}
                </p>
              )}
            </div>

            <div
              className="cursor-pointer py-[15px] px-[30px] flex items-center justify-start bg-darkGray3 gap-[9px]"
              onClick={() => {
                switchLang();
              }}
            >
              <img className="w-[25px]" src={globe} alt="" />
              <p className="text-meta text-white">
                {lang === "th" ? "TH" : "EN"}
              </p>
            </div>
          </div>
        </div>
      </Menu>
    </div>
  );
}
